import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import draggable from "vuedraggable";
import defaultImg from "@/assets/app.png";
import { getAppList, userEditableApps, editCustomAppOrder } from "@/service/appList";
import More from "@/components/AppTemplate/MoreMessage";
export default {
  name: "Apps",
  props: {
    showMore: {
      type: Boolean,
      default() {
        return false;
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  components: {
    More,
    draggable
  },
  data() {
    return {
      defaultImg,
      appList: [],
      felxList: []
    };
  },
  methods: {
    //排序
    async change(data, list) {
      const fromAppId = data.moved.element.id;
      const toAppId = list[data.moved.newIndex + 1].id;
      const data1 = {
        fromAppId,
        toAppId
      };
      const res = await editCustomAppOrder(data1);
      if (res.data.result != 0) {
        this.$Message.error(res.data.msg);
      }
    },
    jump(item) {
      console.log("触发点击事件");
      this.$emit("on-jump", item);
    },
    /*
     ** 如果是saas商城(DSPLAT)和管理后台(MGT) ，过滤不显示
     */
    filterApp(apps) {
      let filterApps = [];
      apps.map(v => {
        let chi = [];
        if (v.apps) {
          chi = v.apps.filter(item => {
            if (item.code !== "DSPLAT" && item.code !== "MGT") {
              return true;
            }
          });
        }
        v.apps = chi;
        filterApps.push(v);
      });
      return filterApps;
    },
    /*
     ** 设置数据为flexList，为了间距保持一致
     */
    setFlexList() {
      let max = 0;
      this.appList.map(v => {
        if (v.apps.length > max) {
          max = v.apps.length;
        }
      });
      this.felxList = new Array(max);
    },
    async getAppList() {
      let api;
      switch (this.type) {
        case "manage":
          api = userEditableApps;
          break;
        default:
          api = getAppList;
          break;
      }
      const res = await api();
      this.appList = this.filterApp(res.data.retVal);
    }
  },
  async mounted() {
    // 获取app列表
    await this.getAppList();
    // app自适应补位数据
    this.setFlexList();
  }
};